
import * as Flags from 'country-flag-icons/react/3x2';

// Mapeamento de nomes PT-BR para códigos ISO
const countryNameToCode: Record<string, string> = {
  // Américas
  'Brasil': 'BR',
  'EUA': 'US',
  'Estados Unidos': 'US',
  'Argentina': 'AR',
  'México': 'MX',
  'Chile': 'CL',
  'Colômbia': 'CO',
  'Peru': 'PE',
  'Uruguai': 'UY',
  'Paraguai': 'PY',
  'Venezuela': 'VE',
  'Equador': 'EC',
  'Bolívia': 'BO',
  'Canadá': 'CA',
  'Cuba': 'CU',
  'Jamaica': 'JM',
  'Haiti': 'HT',
  'República Dominicana': 'DO',
  'Costa Rica': 'CR',
  'Panamá': 'PA',
  'Guatemala': 'GT',
  'Honduras': 'HN',
  'El Salvador': 'SV',
  'Nicarágua': 'NI',
  'Porto Rico': 'PR',
  'Trinidad e Tobago': 'TT',
  
  // Europa
  'Portugal': 'PT',
  'Espanha': 'ES',
  'Alemanha': 'DE',
  'França': 'FR',
  'Itália': 'IT',
  'Reino Unido': 'GB',
  'UK': 'GB',
  'Holanda': 'NL',
  'Países Baixos': 'NL',
  'Bélgica': 'BE',
  'Suíça': 'CH',
  'Áustria': 'AT',
  'Polônia': 'PL',
  'Suécia': 'SE',
  'Noruega': 'NO',
  'Dinamarca': 'DK',
  'Finlândia': 'FI',
  'Irlanda': 'IE',
  'Grécia': 'GR',
  'Ucrânia': 'UA',
  'Romênia': 'RO',
  'Hungria': 'HU',
  'República Tcheca': 'CZ',
  'Eslováquia': 'SK',
  'Croácia': 'HR',
  'Sérvia': 'RS',
  'Bulgária': 'BG',
  'Eslovênia': 'SI',
  'Estônia': 'EE',
  'Letônia': 'LV',
  'Lituânia': 'LT',
  'Luxemburgo': 'LU',
  'Malta': 'MT',
  'Chipre': 'CY',
  'Islândia': 'IS',
  'Albânia': 'AL',
  'Bósnia': 'BA',
  'Macedônia': 'MK',
  'Montenegro': 'ME',
  'Belarus': 'BY',
  'Moldávia': 'MD',
  
  // Ásia
  'Japão': 'JP',
  'China': 'CN',
  'Índia': 'IN',
  'Rússia': 'RU',
  'Coreia do Sul': 'KR',
  'Coreia do Norte': 'KP',
  'Taiwan': 'TW',
  'Singapura': 'SG',
  'Malásia': 'MY',
  'Indonésia': 'ID',
  'Tailândia': 'TH',
  'Vietnã': 'VN',
  'Filipinas': 'PH',
  'Bangladesh': 'BD',
  'Paquistão': 'PK',
  'Sri Lanka': 'LK',
  'Nepal': 'NP',
  'Mianmar': 'MM',
  'Camboja': 'KH',
  'Laos': 'LA',
  'Mongólia': 'MN',
  'Cazaquistão': 'KZ',
  'Uzbequistão': 'UZ',
  'Turquemenistão': 'TM',
  'Quirguistão': 'KG',
  'Tajiquistão': 'TJ',
  'Afeganistão': 'AF',
  'Hong Kong': 'HK',
  'Macau': 'MO',
  'Timor-Leste': 'TL',
  
  // Oriente Médio
  'Turquia': 'TR',
  'Israel': 'IL',
  'Emirados Árabes': 'AE',
  'EAU': 'AE',
  'Arábia Saudita': 'SA',
  'Kuwait': 'KW',
  'Catar': 'QA',
  'Omã': 'OM',
  'Bahrein': 'BH',
  'Jordânia': 'JO',
  'Líbano': 'LB',
  'Síria': 'SY',
  'Iraque': 'IQ',
  'Irã': 'IR',
  'Iêmen': 'YE',
  
  // África
  'Angola': 'AO',
  'África do Sul': 'ZA',
  'Egito': 'EG',
  'Marrocos': 'MA',
  'Nigéria': 'NG',
  'Quênia': 'KE',
  'Moçambique': 'MZ',
  'Cabo Verde': 'CV',
  'Guiné-Bissau': 'GW',
  'São Tomé e Príncipe': 'ST',
  'Gana': 'GH',
  'Senegal': 'SN',
  'Costa do Marfim': 'CI',
  'Camarões': 'CM',
  'Etiópia': 'ET',
  'Tanzânia': 'TZ',
  'Uganda': 'UG',
  'Zimbábue': 'ZW',
  'Ruanda': 'RW',
  'Argélia': 'DZ',
  'Tunísia': 'TN',
  'Líbia': 'LY',
  'Sudão': 'SD',
  'Congo': 'CG',
  'RD Congo': 'CD',
  'Namíbia': 'NA',
  'Botsuana': 'BW',
  'Zâmbia': 'ZM',
  'Maláui': 'MW',
  'Mauritânia': 'MR',
  'Mali': 'ML',
  'Níger': 'NE',
  'Burkina Faso': 'BF',
  'Togo': 'TG',
  'Benin': 'BJ',
  'Guiné': 'GN',
  'Serra Leoa': 'SL',
  'Libéria': 'LR',
  'Gâmbia': 'GM',
  'Somália': 'SO',
  'Eritreia': 'ER',
  'Djibuti': 'DJ',
  'Madagascar': 'MG',
  'Maurício': 'MU',
  'Seychelles': 'SC',
  
  // Oceania
  'Austrália': 'AU',
  'Nova Zelândia': 'NZ',
  'Fiji': 'FJ',
  'Papua Nova Guiné': 'PG',
  'Samoa': 'WS',
  'Tonga': 'TO',
  'Vanuatu': 'VU',
};

export function getCountryCode(countryNameOrCode: string): string {
  // Se já é um código de 2 letras, usa direto
  if (countryNameOrCode.length === 2) {
    return countryNameOrCode.toUpperCase();
  }
  return countryNameToCode[countryNameOrCode] || 'XX';
}

export function CountryFlag({ 
  country, 
  size = 24,
  className = ''
}: { 
  country: string; 
  size?: number;
  className?: string;
}) {
  const code = getCountryCode(country);
  const FlagComponent = (Flags as any)[code];
  
  if (!FlagComponent) {
    return null;
  }
  
  return (
    <FlagComponent 
      title={country}
      className={className}
      style={{ 
        width: size, 
        height: size * 0.67, 
        borderRadius: 2,
        objectFit: 'cover'
      }}
    />
  );
}

export function getCountryFlag(countryNameOrCode: string, size: number = 24) {
  return <CountryFlag country={countryNameOrCode} size={size} />;
}
